import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { Perfil } from '@epms/shared';
import { api, ErrorDeApi } from './api.ts';

export const CLAVE_YO = ['yo'] as const;

/** Perfil del usuario con sesión, o null si no hay sesión. */
export function usePerfil() {
  return useQuery({
    queryKey: CLAVE_YO,
    queryFn: async () => {
      try {
        return await api.get<Perfil>('/api/auth/yo');
      } catch (e) {
        if (e instanceof ErrorDeApi && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000,
  });
}

export function useSalir() {
  const qc = useQueryClient();
  return async () => {
    await api.post('/api/auth/logout').catch(() => {});
    qc.clear();
    qc.setQueryData(CLAVE_YO, null);
  };
}
